import React from 'react';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const sharedClasses = `
    group relative inline-flex items-center justify-center
    bg-copper text-white font-heading font-semibold tracking-wide
    px-8 py-4 text-lg md:text-xl transition-all duration-300
    hover:bg-copper-light hover:shadow-glow hover:-translate-y-1
    active:translate-y-0 active:shadow-none
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const inner = <>
      <span className="relative z-10" data-id="element-201">{children}</span>
      <div className="absolute inset-0 border border-white/20 scale-95 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-300" data-id="element-202" />
    </>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={sharedClasses} data-id="element-203">
        {inner}
      </a>;
  }
  return <button onClick={onClick} className={sharedClasses} data-id="element-204">
      {inner}
    </button>;
}